import { ExportListResponse } from '@core/interface/export-list.interface';
import { ExportPurchaseOrderRequestDto } from '@domain/purchase-order/dtos/export-purchase-order.request.dto';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { UrlBuilder } from '@core/model/url-builder';
import { CreatePurchaseOrderRequestDto } from '@domain/purchase-order/dtos/create-purchase-order.request.dto';
import { ListPurchaseOrderRequestDto } from '@domain/purchase-order/dtos/list-purchase-order.request.dto';
import { PurchaseOrderResponseDto } from '@domain/purchase-order/dtos/purchase-order.response.dto';
import { SummaryPurchaseOrderRequestDto } from '@domain/purchase-order/dtos/summary-purchase-order.request.dto';
import { SummaryPurchaseOrderResponseDto } from '@domain/purchase-order/dtos/summary-purchase-order.response.dto';

@Injectable({
    providedIn: 'root',
})
export class PurchaseOrderService extends UrlBuilder {
    constructor(private http: HttpClient) {
        super('purchase/order');
    }

    create(request: CreatePurchaseOrderRequestDto) {
        const queryUrl = `${this.getApiUrl()}`;
        return this.http.post<ApiResponse<PurchaseOrderResponseDto>>(
            queryUrl,
            request,
        );
    }

    show(request: RefId) {
        const { refId } = request;
        const queryUrl = `${this.getApiUrl()}/show/${refId}`;
        return this.http.get<ApiResponse<PurchaseOrderResponseDto>>(queryUrl, {});
    }

    list(request: ListPurchaseOrderRequestDto) {
        const queryUrl = `${this.getApiUrl()}/list`;
        return this.http.get<
            ApiResponse<PageableResponse<PurchaseOrderResponseDto>>
        >(queryUrl, { params: { ...request } });
    }

    updateState(refId: string, state: string) {
        const queryUrl = `${this.getApiUrl()}/${refId}/state`;
        return this.http.patch<ApiResponse<PurchaseOrderResponseDto>>(
            queryUrl,
            { state },
        );
    }

    export(request: ExportPurchaseOrderRequestDto) {
        const queryUrl = `${this.getApiUrl()}/export`;
        return this.http.post<ApiResponse<ExportListResponse>>(queryUrl, request);
    }

    summary(request: SummaryPurchaseOrderRequestDto) {
        const queryUrl = `${this.getApiUrl()}/summary`;
        return this.http.get<ApiResponse<SummaryPurchaseOrderResponseDto>>(
            queryUrl,
            { params: { ...request } },
        );
    }
}